export enum ESmartFilterCompareMarks {
  LESS_THAN = '<',
  LESS_THAN_OR_EQUAL = '<=',
  GREATER_THAN = '>',
  GREATER_THAN_OR_EQUAL = '>=',
  EQUAL = '=',
}

export enum ESmartFilterCompareSeparators {
  OR = '||',
  AND = '&&',
}

export enum ESmartFilterCompareInputsPath {
  FIRST_CONDITION_FIRST_MARK = 'first_condition.first.mark',
  FIRST_CONDITION_FIRST_VALUE = 'first_condition.first.value',
  FIRST_CONDITION_SECOND_MARK = 'first_condition.second.mark',
  FIRST_CONDITION_SECOND_VALUE = 'first_condition.second.value',
  SECOND_CONDITION_FIRST_MARK = 'second_condition.first.mark',
  SECOND_CONDITION_FIRST_VALUE = 'second_condition.first.value',
  SECOND_CONDITION_SECOND_MARK = 'second_condition.second.mark',
  SECOND_CONDITION_SECOND_VALUE = 'second_condition.second.value',
  SEPARATOR = 'compare_separator',
}

export enum ESmartFilterColumnType {
  COMPARE = 'COMPARE',
  CHECKBOX = 'CHECKBOX',
  DATE = 'DATE',
}
